<template>
  <button
    type="button"
    class="bg-gray-10 enabled:hover:bg-gray-20 enabled:hover:text-gray-80 text-gray-70 disabled:bg-gray-10 enabled:active:!bg-active-secondary enabled:active:!text-active-icon flex shrink-0 items-center justify-center mix-blend-multiply transition-colors disabled:cursor-not-allowed disabled:text-gray-50"
    :class="[small ? 'h-6 w-6' : 'h-8 w-8', rounded ? 'rounded-full' : 'rounded']"
  >
    <x-icon :class="[small ? 'icon-s' : 'icon-m']" />
  </button>
</template>

<script setup lang="ts">
import { XIcon } from '@klausapp/ui-kit/icons'

withDefaults(
  defineProps<{
    small?: boolean
    rounded?: boolean
  }>(),
  {
    type: 'button',
    small: false,
    rounded: false,
  },
)
</script>
